// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconPackage, IconLayout, IconTruckDelivery, IconBoxPadding, IconTag, IconCloudUpload } from '@tabler/icons';

// constant
const icons = {
    IconPackage,
    IconLayout,
    IconTruckDelivery,
    IconBoxPadding,
    IconTag,
    IconCloudUpload
};

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const catalogue = {
    id: 'catalogue-roadmap',
    type: 'group',
    title: <FormattedMessage id="catalogue" />,
    children: [
        {
            id: 'products',
            title: <FormattedMessage id="products" />,
            type: 'item',
            url: '/loolu/admin/products',
            icon: icons.IconPackage,
            external: false,
            breadcrumbs: false
        },
        {
            id: 'brands',
            title: <FormattedMessage id="brands" />,
            type: 'item',
            url: '/loolu/admin/brands',
            icon: icons.IconLayout,
            external: false,
            breadcrumbs: false
        },
        {
            id: 'supplier',
            title: <FormattedMessage id="vendors" />,
            type: 'item',
            url: '/loolu/admin/vendors',
            icon: icons.IconTruckDelivery,
            external: false,
            breadcrumbs: false
        },
        {
            id: 'facets',
            title: 'Facets',
            type: 'item',
            url: '/loolu/admin/facets',
            icon: icons.IconBoxPadding,
            external: false,
            breadcrumbs: false
        },
        {
            id: 'categories',
            title: <FormattedMessage id="categories" />,
            type: 'item',
            url: '/loolu/admin/categories',
            icon: icons.IconTag,
            external: false,
            breadcrumbs: false
        },
        {
            id: 'massive_load',
            title: <FormattedMessage id="massive_load" />,
            type: 'item',
            url: '/loolu/admin/massive_load',
            icon: icons.IconCloudUpload,
            external: false,
            breadcrumbs: false
        }
    ]
};

export default catalogue;
